module.exports = __webpack_public_path__ + "img/mass-coupon-inactive@3x.png";